import React, { useState, useContext, createContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Row, Col, Select, Input, Button, DatePicker } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/zh_CN';
import mapper from 'object-mapper';
import querystring from 'querystring';
import at from 'lodash/at';
import moment from 'moment';
import { cloneDeep } from 'lodash';

import { fetchBaseInfo } from '@/Actions/Baseinfo';

import SectionWrapper from './../../SectionWrapper';
import SearchInput from './Input';
import ItemOrdersStatus from '@/Components/Common/Search/FormItemOrdersStatus';
import FormItemPlatformShops from '@/Components/Common/Search/FormItemPlatformShops';

import './Orders.css';

const EditableContext = createContext();
const Option = Select.Option;
const RangePicker = DatePicker.RangePicker;
const dateFormat = 'YYYY-MM-DD';
const quickRange = {
  '今天': [moment(), moment()],
  '近7天': [moment().subtract(7, 'days'), moment()],
  '近30天': [moment().subtract(30, 'days'), moment()],
  '近60天': [moment().subtract(60, 'days'), moment()],
};

let _count = 0;

export default (props) => {
  const dispatch = useDispatch();
  const [expand, setExpand] = useState(false);
  const [count, setCount] = useState(0);
  const [form] = Form.useForm();
  const { sort, initialValue, hides } = props.defaultValue;

  if (true !== initialValue.hasOwnProperty('booking_month')) {
    hides.push('booking_month');
  }
  if (true !== initialValue.hasOwnProperty('departure_month')) {
    hides.push('departure_month');
  }
  const { onSubmit } = props;
  const _quickRange = cloneDeep(props.quickRange) || quickRange;

  const onFinish = (values) => {
    console.log('Received values of form: ', values);
    const destinationObject = {
      'type': {
        key: 'type',
        default: 'search',
      },
      'ordersn': {
        key: 'ordersn',
        default: '',
      },
      'account': {
        key: 'account',
        default: '',
      },
      'product_name': {
        key: 'product_name',
        default: '',
      },
      'product_labels': {
        key: 'product_labels',
        default: [],
        transform: (value) =>
          value === '' || !Array.isArray(value) ? undefined : value.map((t) => String(t).trim()).join(','),
      },
      'booking_date': {
        key: 'booking_date',
        transform: (value) =>
          value === '' || !Array.isArray(value)
            ? undefined
            : value.map((item) => moment(item).format('YYYY-MM-DD')).join(','),
        default: '',
      },
      'departure_date': {
        key: 'departure_date',
        transform: (value) =>
          value === '' || !Array.isArray(value)
            ? undefined
            : value.map((item) => moment(item).format('YYYY-MM-DD')).join(','),
        default: '',
      },
      'is_online': {
        key: 'is_online',
        default: '',
      },
      'wj': {
        key: 'wj',
        transform: (value) => (value ? value.join(',') : ''),
        default: '',
      },
      'status': {
        key: 'status',
        transform: (value) => (value ? value.map((item) => item.key).join(',') : ''),
        default: '',
      },
      'destination': {
        key: 'destination',
        transform: (value) => (value ? (!isNaN(parseInt(value.key), 10) ? value.key : '') : ''),
        default: '',
      },
      'area_side': {
        key: 'area_side',
        default: '',
      },
      'saler_id': {
        key: 'saler_id',
        transform: (value) => (value ? (!isNaN(parseInt(value.key), 10) ? value.key : '') : ''),
        default: '',
      },
      'is_shipment': {
        key: 'is_shipment',
        default: '',
      },
      'is_operator_confirm': {
        key: 'is_operator_confirm',
        default: '',
      },
      'is_click_farm': {
        key: 'is_click_farm',
        default: '',
        transform: (value) => (value ? (!isNaN(parseInt(value.key), 10) ? value.key : '') : ''),
      },
      'department_id': {
        key: 'department_id',
        transform: (value) => (value ? value.join(',') : ''),
        default: '',
      },
      'groups_no': {
        key: 'groups_no',
        default: '',
      },
      'seller_flag': {
        key: 'seller_flag',
        transform: (value) => (value ? value.join(',') : ''),
        default: '',
      },
      'arrangement': {
        key: 'arrangement',
        default: '',
      },
      'supplier_id': {
        key: 'supplier_id',
        transform: (value) => (value ? (!isNaN(parseInt(value.key), 10) ? value.key : '') : ''),
        default: '',
      },
      'name': {
        key: 'name',
        default: '',
      },
      'phone': {
        key: 'phone',
        default: '',
      },
      'dividers_id': {
        key: 'dividers_id',
        default: '1,2',
      },
      'profit_margin': {
        key: 'profit_margin',
        transform: (value, objFrom) => {
          return undefined;
          // return ((+objFrom.profit_margin_b1) === 0 && (+objFrom.profit_margin_b2) === 0) ? '' : `${objFrom.profit_margin_b1 * 0.01},${objFrom.profit_margin_b2 * 0.01}`
        },
        default: '',
      },
      'booking_month': {
        key: 'booking_month',
        transform: (value) => {
          return value === undefined || value === null ? undefined : moment(value).format('YYYY-MM');
        },
        default: '',
      },
      'departure_month': {
        key: 'departure_month',
        transform: (value) => {
          return value === undefined || value === null ? undefined : moment(value).format('YYYY-MM');
        },
        default: '',
      },
      'supplier_suffix_id': {
        key: 'supplier_suffix_id',
        transform: (value) => (value ? value.key : ''),
        default: '',
      },
      'pc_id': {
        key: 'pc_id',
        transform: (value) => (value ? (!isNaN(parseInt(value.key), 10) ? value.key : '') : ''),
        default: '',
      },
      'platform_shop_id': [
        // { 'key': 'shop', 'transform': (value) => (value || [])[1] ?? '' },
        { 'key': 'shop_id', 'transform': (value) => (value || [])[1] ?? '' },
        // { 'key': 'platform', 'transform': (value) => (value || [])[0] ?? '' },
        { 'key': 'pf_id', 'transform': (value) => (value || [])[0] ?? '' },
        { 'key': 'web_source', 'transform': (value) => (value || [])[0] ?? '' },
      ],
      'is_departure_date': {
        key: 'is_departure_date',
        default: ''
      },
    };
    let dest = {};
    dest = mapper(values, destinationObject);
    dest = mapper.setKeyValue(dest, 'code', 'utf-8');
    for (const key in dest) {
      if (['name', 'phone', 'product_name', 'groups_no', 'ordersn'].includes(key)) {
        dest[key] = typeof dest[key] === 'string' ? (dest[key] || '').replace(/(^\s*)|(\s*$)/g, '') : dest[key];
        dest[key] = typeof dest[key] === 'string' ? (dest[key] || '').replace(/，|,/g, ',') : dest[key];
      }
    }
    // Object.keys(dest).forEach(
    //   (key) => (dest[key] == null || dest[key] == '' || dest[key].length === 0) && delete dest[key]
    // );
    const str = querystring.encode(dest);
    if (typeof onSubmit === 'function') {
      onSubmit(null, str, dest);
    }
  };

  const onReset = () => {
    form.setFieldsValue({
      'ordersn': undefined,
      'account': undefined,
      'product_name': undefined,
      'product_labels': undefined,
      'booking_date': undefined,
      'departure_date': undefined,
      'web_source': undefined,
      'is_online': undefined,
      'wj': undefined,
      'status': undefined,
      'destination': undefined,
      'area_side': undefined,
      'saler_id': undefined,
      'profit_margin_b1': undefined,
      'profit_margin_b2': undefined,
      'is_shipment': undefined,
      'is_click_farm': undefined,
      'is_operator_confirm': undefined,
      'department_id': undefined,
      'groups_no': undefined,
      'seller_flag': undefined,
      'arrangement': undefined,
      'supplier_id': undefined,
      'name': undefined,
      'phone': undefined,
      'shop_id': undefined,
      'dividers_id': '1,2',
      'booking_month': undefined,
      'departure_month': undefined,
      'supplier_suffix_id': undefined,
      'pc_id': undefined,
    });
  };

  return [
    <SectionWrapper id="Search" title={props.title || 'Search'} key="1">
      <Form form={form} name="advanced_search" className="orders-search-form" onFinish={onFinish}>
        <EditableContext.Provider value={form}>
          <Row gutter={24}>{getFields({ sort, initialValue, hides, expand, setCount, _quickRange })}</Row>
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button type="primary" htmlType="submit">
                搜索
              </Button>
              <Button style={{ margin: '0 8px' }} onClick={onReset}>
                重置
              </Button>
              {(() => {
                if (_count > 6) {
                  return (
                    <a
                      style={{ fontSize: 12 }}
                      onClick={() => {
                        setExpand(!expand);
                      }}
                    >
                      {expand ? <UpOutlined /> : <DownOutlined />} 更多
                    </a>
                  );
                }
              })()}
            </Col>
          </Row>
        </EditableContext.Provider>
      </Form>
    </SectionWrapper>,
    <div key="2">{props.children}</div>,
  ];
};

function getFields(props) {
  const ProductsCategory = (sprops) => {
    return (
      <Form.Item label="项目名称">
        <Input.Group compact>
          <Form.Item
            name={`product_name`}
            noStyle
            initialValue={at(props, 'initialValue.product_name')[0] || undefined}
          >
            <Input style={{ width: '70%' }} />
          </Form.Item>
          <Form.Item name={`pc_id`} noStyle>
            <SearchInput
              style={{ width: '30%' }}
              url="/api/products/category"
              autoGet={true}
              map={{ 'data[].pc_id': '[].key', 'data[].title': '[].label' }}
            />
          </Form.Item>
        </Input.Group>
      </Form.Item>
    );
  };

  const item = (name, sort = 0, render) => {
    return {
      'key': '',
      'sort': sort,
      'name': name,
      'hide': false,
      'render': render,
    };
  };

  let baseChildren = [];
  baseChildren = [
    item(
      'ordersn',
      99,
      <Form.Item
        name={`ordersn`}
        label={`订单号`}
        key="11"
        initialValue={at(props, 'initialValue.ordersn')[0] || undefined}
      >
        <Input />
      </Form.Item>
    ),
    item(
      'seller_flag',
      99,
      <Form.Item name={`seller_flag`} label={`订单标记`}>
        <Select
          dropdownMatchSelectWidth={false}
          allowClear={true}
          mode={'multiple'}
          maxTagCount={0}
          maxTagPlaceholder={(omittedValues) => ` + ${omittedValues.length} 更多...`}
        >
          <Option value="1">
            <span style={{ color: '#ff0000' }}>F</span>-红
          </Option>
          <Option value="2">
            <span style={{ color: '#ffff00' }}>F</span>-黄
          </Option>
          <Option value="3">
            <span style={{ color: '#008000' }}>F</span>-绿
          </Option>
          <Option value="4">
            <span style={{ color: '#0000ff' }}>F</span>-蓝
          </Option>
          <Option value="5">
            <span style={{ color: '#800080' }}>F</span>-紫
          </Option>
        </Select>
      </Form.Item>
    ),
    item(
      'account',
      99,
      <Form.Item name={`account`} label={`买家昵称`}>
        <Input />
      </Form.Item>
    ),
    item(
      'product_name',
      99,
      <ProductsCategory />
      // <Form.Item
      //   name={`product_name`}
      //   label={`项目名称`}
      //   initialValue={at(props, 'initialValue.product_name')[0] || undefined}
      // >
      //   <Input />
      // </Form.Item>
    ),
    item(
      'product_labels',
      99,
      <Form.Item name={`product_labels`} label={`产品标签`}>
        <Select mode="tags" open={false} placeholder="输入标签，回车分隔"></Select>
      </Form.Item>
    ),
    item(
      'booking_month',
      99,
      <Form.Item
        name={'booking_month'}
        label={'预订月份'}
        initialValue={at(props, 'initialValue.booking_month')[0] || undefined}
      >
        <DatePicker picker="month" style={{ width: '100%' }} locale={locale} />
      </Form.Item>
    ),
    item(
      'departure_month',
      99,
      <Form.Item
        name={'departure_month'}
        label={'出行月份'}
        initialValue={at(props, 'initialValue.departure_month')[0] || undefined}
      >
        <DatePicker picker="month" style={{ width: '100%' }} locale={locale} />
      </Form.Item>
    ),
    item(
      'booking_date',
      99,
      <Form.Item
        name={`booking_date`}
        label={`预订日期`}
        // initialValue={[moment('2015/01/01', dateFormat), moment('2015/01/01', dateFormat)]}
        initialValue={at(props, 'initialValue.booking_date')[0] || undefined}
      >
        <RangePicker ranges={props._quickRange} format={dateFormat} style={{ width: '100%' }} locale={locale} />
      </Form.Item>
    ),
    item(
      'departure_date',
      99,
      <Form.Item
        name={`departure_date`}
        label={`出行日期`}
        initialValue={at(props, 'initialValue.departure_date')[0] || undefined}
      >
        <RangePicker ranges={props._quickRange} format={dateFormat} style={{ width: '100%' }} locale={locale} />
      </Form.Item>
    ),
    item(
      'destination',
      99,
      <Form.Item label="成交地区">
        <Input.Group compact>
          <Form.Item name={`area_side`} noStyle initialValue={at(props, 'initialValue.area_side')[0] || undefined}>
            <Select onChange={(e) => {}} style={{ width: '30%' }} allowClear={true}  >
              <Option value="inside">境内</Option>
              <Option value="outside">境外</Option>
              <Option value="customized">定制</Option>
            </Select>
          </Form.Item>
          <Form.Item name={`destination`} noStyle initialValue={at(props, 'initialValue.destination')[0] || undefined}>
            <SearchInput
              style={{ width: '70%' }}
              url="/api/area"
              map={{ 'data.data[].a_id': '[].key', 'data.data[].label': '[].label' }}
            />
          </Form.Item>
        </Input.Group>
      </Form.Item>
    ),
    item(
      'platform_shop_id',
      99,
      <Form.Item
        name={`platform_shop_id`}
        label={`平台店铺`}
        initialValue={at(props, 'initialValue.platform_shop_id')[0] || undefined}
      >
        <FormItemPlatformShops multiple hideTitle />
      </Form.Item>
    ),
    item(
      'saler_id',
      99,
      <Form.Item name={`saler_id`} label={`成交销售`} initialValue={at(props, 'initialValue.saler')[0] || undefined}>
        <SearchInput url="/api/users" map={{ 'data.data[].u_id': '[].key', 'data.data[].real_name': '[].label' }} />
      </Form.Item>
    ),
    item(
      'department_id',
      99,
      <Form.Item name={`department_id`} label={`所属小组`}>
        <Select
          dropdownMatchSelectWidth={false}
          allowClear={true}
          mode={'multiple'}
          maxTagCount={0}
          maxTagPlaceholder={(omittedValues) => ` + ${omittedValues.length} 更多...`}
        > 
          <Option key="22" value="22">
          自由行一组（境内+欧澳）
          </Option>
          <Option key="23" value="23">
          自由行二组（中东非+日韩印菲）
          </Option>
          <Option key="24" value="24">
          自由行三组（美洲+中南半岛）
          </Option>
          <Option key="25" value="25">
          定制小组
          </Option>
          {/* <Option key="16" value="16">
            境内
          </Option>
          <Option key="15" value="15">
          境外
          </Option>
          <Option key="17" value="17">
            东南亚(1组)
          </Option>
          <Option key="18" value="18">
            欧美(2组)
          </Option>
          <Option key="19" value="19">
            机酒(3组)
          </Option>
          <Option key="20" value="20">
            酒店
          </Option> */}
        </Select>
      </Form.Item>
    ),
    item(
      'is_shipment',
      99,
      <Form.Item name={`is_shipment`} label={`出单状态`}>
        <Select allowClear={true}>
          <Option value="0">未出单</Option>
          <Option value="1">已出单</Option>
        </Select>
      </Form.Item>
    ),
    item(
      'is_operator_confirm',
      99,
      <Form.Item name={`is_operator_confirm`} label={`计调确认`}>
        <Select allowClear={true}>
          <Option value="0">未确认</Option>
          <Option value="1">已确认</Option>
        </Select>
      </Form.Item>
    ),
    item(
      'status',
      99,
      <Form.Item name={`status`} label={`订单状态`} initialValue={at(props, 'initialValue.status')[0] || undefined}>
        <ItemOrdersStatus />
      </Form.Item>
    ),
    item(
      'arrangement',
      99,
      <Form.Item name={`arrangement`} label={`订单安排`}>
        <Select allowClear={true}>
          <Option value="0">可安排</Option>
          <Option value="1">不可安排</Option>
        </Select>
      </Form.Item>
    ),
    item(
      'groups_no',
      99,
      <Form.Item name={`groups_no`} label={`团号`}>
        <Input />
      </Form.Item>
    ),
    item(
      'name',
      99,
      <Form.Item name={`name`} label={`姓名`}>
        <Input />
      </Form.Item>
    ),
    item(
      'phone',
      99,
      <Form.Item name={`phone`} label={`联系电话`}>
        <Input />
      </Form.Item>
    ),
    item(
      'is_click_farm',
      99,
      <Form.Item
        name={`is_click_farm`}
        label={`平台刷单`}
        initialValue={at(props, 'initialValue.is_click_farm')[0] || { key: '0', label: '否' }}
      >
        <Select labelInValue={true}>
          <Option value="0">否</Option>
          <Option value="1">是</Option>
        </Select>
      </Form.Item>
    ),
    item(
      'wj',
      99,
      <Form.Item name={`wj`} label={`微建状态`}>
        <Select
          dropdownMatchSelectWidth={false}
          allowClear={true}
          mode={'multiple'}
          maxTagCount={0}
          maxTagPlaceholder={(omittedValues) => ` + ${omittedValues.length} 更多...`}
        >
          <Option value="0">未操作</Option>
          <Option value="1">我加客人，客人没加我</Option>
          <Option value="2">已加</Option>
          <Option value="3">已建群</Option>
        </Select>
      </Form.Item>
    ),
    item(
      'profit_margin',
      99,
      <Form.Item name={`profit_margin_b1`} label={`利润率`}>
        <Input />
      </Form.Item>
    ),
    item(
      'supplier_id',
      99,
      <Form.Item
        // name={`supplier_id`}
        label={`供应商`}
        // initialValue={at(props, 'initialValue.supplier_id')[0] || undefined}
      >
        {/* <SearchInput url='/api/supplier/name' map={{ 'data[].s_id': '[].key', 'data[].company': '[].label' }} /> */}

        <SupplierMenu initialValue={at(props, 'initialValue.supplier_id')[0] || undefined} />
      </Form.Item>
    ),
    item(
      'is_departure_date',
      99,
      <Form.Item
        name={`is_departure_date`}
        label={`出行日期为空`}
      >
        <Select 
          allowClear={true}>
          <Option value="2">否</Option>
          <Option value="1">是</Option>
        </Select>
      </Form.Item>
    ),
  ];

  baseChildren = baseChildren
    .map((x) => {
      if (props.sort === undefined) {
        return x;
      }
      const tmpSort = props.sort;
      for (const key in tmpSort) {
        if (tmpSort.hasOwnProperty(key)) {
          if (x.name === key) {
            x.sort = tmpSort[key];
          }
        }
      }
      return x;
    })
    .map((x) => {
      if (props.hides === undefined) {
        return x;
      }
      for (const key of props.hides) {
        // console.log(11111, x.name, key, x.name === key);
        if (x.name === key) {
          x.sort = Number.MAX_VALUE;
          x.hide = true;
        }
      }
      return x;
    })
    .sort((a, b) => {
      if (a.sort < b.sort) return -1;
      if (a.sort > b.sort) return 1;
    });
  const count = props.expand ? baseChildren.length : 6;
  const children = [];
  for (let i = 0; i < baseChildren.length; i++) {
    let Item = (
      <Col span={8} key={String(i)} style={{ display: i < count && !baseChildren[i].hide ? 'block' : 'none' }}>
        {baseChildren[i].render}
      </Col>
    );
    children.push(Item);
  }
  // console.log(baseChildren);
  baseChildren.forEach((item) => (!item.hide ? ++_count : ''));
  // props.setCount(_count);
  return children;
}

const SInput = (props) => {
  const { toggleEdit, onChange, setContacts, ..._props } = props;
  const [suppliers, setSuppliers] = useState([]);
  return (
    <Form.Item name={`supplier_id`} noStyle initialValue={props.value}>
      <SearchInput
        {..._props}
        onChange={(value) => {
          if (!value) {
            value = { key: '', label: '', contacts: '' };
          }
          setContacts(
            suppliers
              .filter((item) => String(item.key) === String(value.key))
              .map((item) => JSON.parse(item.contacts))[0] || []
          );
        }}
        onSearchAfter={(list, value) => {
          setSuppliers((list || []).filter((item) => JSON.parse(item.contacts || '[]').length > 0));
        }}
        url="/api/supplier/name"
        map={{ 'data[].s_id': '[].key', 'data[].company': '[].label', 'data[].contacts': '[].contacts' }}
        dropdownMatchSelectWidth={false}
      />
    </Form.Item>
  );
};

const SuffixSelect = (props) => {
  // console.log('props', props)
  const { toggleEdit, onSearchAfter, ..._props } = props;
  const [v, setV] = useState([]);
  const [data, setData] = useState([]);
  // useEffect(() => {
  //   setV(String(props.value.key) === '' || props.value.length === 0 ? [] : props.value);
  // }, [props.value]);
  useEffect(() => {
    setData(props.data);
  }, [props.data]);
  return (
    <Form.Item name={`supplier_suffix_id`} noStyle>
      <Select
        {..._props}
        value={v.length === 0 ? _props.value : v}
        labelInValue
        dropdownMatchSelectWidth={false}
        allowClear={true}
        onChange={(e) => {
          if (!e) {
            e = { key: '', label: '' };
          }
          setV(e);
          // toggleEdit({ name: 'supplier_suffix_id', value: e.key });
        }}
      >
        {(data || []).map((item, index) => {
          return <Option key={String(item.ID)}>{item.name}</Option>;
        })}
      </Select>
    </Form.Item>
  );
};

class SupplierMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'contacts': [],
    };
  }

  setContacts = (data) => {
    this.setState({ 'contacts': data });
  };

  render() {
    const { onSearchAfter, ...props } = this.props;
    const contacts = this.state.contacts.length > 0 ? this.state.contacts : [];

    if (contacts.length === 0) {
      return (
        <SInput
          {...{ ...props }}
          value={this.props.initialValue}
          onChange={(value) => props.onChange(value)}
          setContacts={this.setContacts}
        />
      );
    }
    return (
      <Input.Group compact>
        <SInput
          {...{ ...props }}
          style={{ width: '60%' }}
          onChange={(value) => props.onChange(value)}
          setContacts={this.setContacts}
        />
        <SuffixSelect style={{ width: '35%' }} data={contacts} />
      </Input.Group>
    );
  }
}
